import { render } from "./CadernoConcluintes.vue?vue&type=template&id=6c730f24&scoped=true"
import script from "./CadernoConcluintes.vue?vue&type=script&lang=js"
export * from "./CadernoConcluintes.vue?vue&type=script&lang=js"

import "./CadernoConcluintes.vue?vue&type=style&index=0&id=6c730f24&scoped=true&lang=css"
import "./CadernoConcluintes.vue?vue&type=style&index=1&id=6c730f24&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c730f24"]])

export default __exports__